import { type StatsigClient, useFeatureGate } from '@statsig/react-bindings';

export type FeatureGateOptions = {
  default: boolean;
};

export type FeatureGate = [
  useFG: (options?: FeatureGateOptions) => boolean,
  checkFG: (client: StatsigClient, options?: FeatureGateOptions) => boolean,
];

const DEFAULT_OPTIONS: FeatureGateOptions = { default: false };

export const createFeatureGate = (key: string, options: FeatureGateOptions = DEFAULT_OPTIONS): FeatureGate => {
  const useFG = (opts: FeatureGateOptions = options) => {
    const featureGate = useFeatureGate(key);
    if (featureGate.details?.reason === 'NoValues') {
      return opts.default;
    }
    return featureGate.value;
  };

  const checkFG = (client: StatsigClient, opts: FeatureGateOptions = options) => {
    const featureGate = client.getFeatureGate(key);
    if (featureGate.details?.reason === 'NoValues') {
      return opts.default;
    }
    return featureGate.value;
  };

  return [useFG, checkFG];
};
